import { useCallback, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { articleModerationApi } from './articleModerationApi'
import type { ModerationState } from './types'

/**
 * Чтение кеша БЕЗ подписки (как `useCourseModeration`): запрос ведёт единственный
 * `ArticleModerationPoller`. «Не знаем» — `state === undefined`, лок не ставится.
 */
export const useArticleModeration = (
  id: number | null,
): { state: ModerationState | undefined; isError: boolean; refetch: () => void } => {
  const dispatch = useAppDispatch()
  const select = useMemo(
    () => articleModerationApi.endpoints.getArticleModeration.select(id ?? -1),
    [id],
  )
  const result = useAppSelector(select)
  const refetch = useCallback(() => {
    if (id === null) return
    void dispatch(
      articleModerationApi.endpoints.getArticleModeration.initiate(id, {
        forceRefetch: true,
        subscribe: false,
      }),
    )
  }, [id, dispatch])
  return { state: id === null ? undefined : result.data, isError: result.isError, refetch }
}

/** Статья на проверке — форма и действия заморожены. */
export const useIsArticleFrozen = (id: number | null): boolean =>
  useArticleModeration(id).state?.review?.status === 'pending'
